import "./contact.css";
import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import { selectUserLanguage } from "../../features/user/userSlice";
import useLanguage from "../../hooks/useLanguage";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import HambMenu from "../../components/hamburger-menu/HambMenu";
import { setLanguage } from "../../features/user/userSlice";

const Contact = () => {
  const dispatch = useDispatch();
  const currentLanguage = useSelector(selectUserLanguage) || "es";

  // Get texts based on current language
  const texts = useLanguage(currentLanguage, "views.landingPage");

  useEffect(() => {
    if (!currentLanguage) {
      dispatch(setLanguage("es"));
    }
  }, [currentLanguage, dispatch]);

  const [showMenu, setShowMenu] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    enterpriseName: "",
    employeePosition: "",
    employeesNumber: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Check if all fields are filled
    if (
      formData.name === "" ||
      formData.email === "" ||
      formData.enterpriseName === "" ||
      formData.employeePosition === "" ||
      formData.employeesNumber === "" ||
      formData.message === ""
    ) {
      alert(texts.contact.alerts.allFieldsRequired);
      return;
    }

    // Check if the number of employees is a numeric value
    if (isNaN(formData.employeesNumber)) {
      alert(texts.contact.alerts.employeesNumberRequired);
      return;
    }

    const subject = encodeURIComponent("New message from contact form");
    const body = encodeURIComponent(
      `Name: ${formData.name}\n` +
        `Email: ${formData.email}\n` +
        `Enterprise Name: ${formData.enterpriseName}\n` +
        `Employee Position: ${formData.employeePosition}\n` +
        `Employees Number: ${formData.employeesNumber}\n\n` +
        `Message:\n${formData.message}`
    );

    // Dirección de correo a donde llegaran los mails
    const to = "op@amvi.app";

    // Abrir cliente de correo
    window.location.href = `mailto:${to}?subject=${subject}&body=${body}`;

    alert(texts.contact.alerts.messageSentSuccessfully);
    setFormData({
      name: "",
      email: "",
      enterpriseName: "",
      employeePosition: "",
      employeesNumber: "",
      message: "",
    });
  };

  return (
    <>
      <Header
        texts={texts}
        showMenu={showMenu}
        setShowMenu={setShowMenu}
        inLandingPage={false}
      />
      {!showMenu ? (
        <div className="contact-container-background">
          <div className="contact-container">
            <div className="contact-header">
              <h2>{texts.contact.title}</h2>
            </div>
            <div className="contact-form-field">
              <label htmlFor="name" className="sr-only">
                {texts.contact.form.name}
              </label>
              <input
                id="name"
                name="name"
                type="text"
                required
                value={formData.name}
                onChange={handleChange}
                className="contact-input"
              />
            </div>
            <div className="contact-form-field">
              <label htmlFor="email" className="sr-only">
                {texts.contact.form.email}
              </label>
              <input
                id="email"
                name="email"
                type="email"
                required
                value={formData.email}
                onChange={handleChange}
                className="contact-input"
              />
            </div>
            <div className="contact-form-field">
              <label htmlFor="enterpriseName" className="sr-only">
                {texts.contact.form.enterpriseName}
              </label>
              <input
                id="enterpriseName"
                name="enterpriseName"
                type="text"
                required
                value={formData.enterpriseName}
                onChange={handleChange}
                className="contact-input"
              />
            </div>
            <div className="contact-employee-container">
              <div className="contact-form-field">
                <label htmlFor="employeePosition" className="sr-only">
                  {texts.contact.form.employeePosition}
                </label>
                <input
                  id="employeePosition"
                  name="employeePosition"
                  type="text"
                  required
                  value={formData.employeePosition}
                  onChange={handleChange}
                  className="contact-input"
                />
              </div>
              <div className="contact-form-field">
                <label htmlFor="employeesNumber" className="sr-only">
                  {texts.contact.form.employeesNumber}
                </label>
                <input
                  id="employeesNumber"
                  name="employeesNumber"
                  type="text"
                  required
                  value={formData.employeesNumber}
                  onChange={handleChange}
                  className="contact-input"
                />
              </div>
            </div>
            <div className="contact-form-field">
              <label htmlFor="message" className="sr-only">
                {texts.contact.form.message}
              </label>
              <textarea
                id="message"
                name="message"
                required
                value={formData.message}
                onChange={handleChange}
                className="contact-textarea"
              ></textarea>
            </div>
            <div>
              <button className="contact-submit-button" onClick={handleSubmit}>
                {texts.contact.form.submit}
              </button>
            </div>
          </div>
          <Footer inLandingPage={false} />
        </div>
      ) : (
        <HambMenu
          showMenu={showMenu}
          setShowMenu={setShowMenu}
          inLandingPage={false}
        />
      )}
    </>
  );
};

export default Contact;
